import React, {Component} from "react";
import Cookies from "universal-cookie";
import hidepwdicon from "../images/hide.png";
import showpwdicon from "../images/view.png";
//import {jsPDF} from "jspdf";
//import html2canvas from "html2canvas";
//import { usePDF } from "react-to-pdf";



const ref = React.createRef();
const axios = require("axios");
//const location = useLocation();
const cookies=new Cookies();
class Login extends Component{
    constructor(props) {
        super();
        this.state = {input:{}, isRevealPwd:true, errors: {email:"",password:""}, myItems:[],emp:"",empname:"" ,error:'',errorcss:"text-danger",bdisabled:false};
        this.myChangeHandler = this.myChangeHandler.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
      }
        componentDidMount(){
            if( cookies.get('LoginID'))
            {   
              cookies.remove('LoginID');
            } // Pacman
            console.log(cookies.get("phpclass"));
        }
            myChangeHandler(event) {
                let input = this.state.input;
                input[event.target.name] = event.target.value;
                this.setState({input});
          }
        handleLogin = (event) => {

          document.body.classList.add('busy-cursor');
          event.preventDefault();
          let isValid = true;
          this.setState({
            myItems: []
          });
          if(this.validate())
          {
            this.setState({bdisabled:true});
            axios({
              method: 'post',
              url: cookies.get("phpclass")+"/index.php/user/sign_in/",
              data: this.state.input,
              headers: {'Content-Type': 'multipart/form-data'}
              })  
              .then((res) => {
                console.log(res.data);
                document.body.classList.remove('busy-cursor');
                let errors={};
                if(res.data==="0")
                { 
                  errors["email"] = "Please enter valid email Address.";
                }
                else if(res.data==="1")
                {
                    errors["password"]= "Incorrect Password entered";
                }
                else
                {                
                    this.setState({emp: res.data[0].Emp_id, empname: res.data[0].name});
                    cookies.set('LoginID', this.state.emp, { path: '/' });
                    cookies.set('EmpName', this.state.empname, { path: '/' });
                    cookies.set('vh', res.data[0].vh, { path: '/' });
                    cookies.set('cnic', res.data[0].nic, { path: '/' });
                    cookies.set('contract_year', res.data[0].contract_year, { path: '/' });


                    if(res.data[0].auth > 0)
                      cookies.set('Auth', "block", { path: '/' });
                    else
                      cookies.set('Auth', "none", { path: '/' });
                      cookies.set('Admin', res.data[0].isAdmin, { path: '/' });

/*                    if(res.data[0].isAdmin === 1)


                      cookies.set('Admin', "block", { path: '/' });
                    else if(res.data[0].isAdmin === 2)
                      cookies.set('Admin2', "block", { path: '/' });
                    else if(res.data[0].isAdmin === 3)
                      cookies.set('Admin3', "block", { path: '/' });
                    else
                      cookies.set('Admin', "none", { path: '/' });*/

                      window.location.href="https://"+document.location.hostname+"/hr";

                    }
                  isValid = false;
                  this.setState({errors: errors,bdisabled:false});              
            })
            .catch=()=> {
              document.body.classList.remove('busy-cursor');
              this.setState({error:"Unable to login this time, please try later",errorcss:"text-danger"});
            }; 
        }
      return isValid;
      }
        validate(){
            let input = this.state.input;
            let errors = {};
            let isValid = true;
            if (!input["email"]) {
              isValid = false;
              errors["email"] = "Please enter your email Address.";
            }
            if (typeof input["email"] !== "undefined") {   
              var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
              if (!pattern.test(input["email"])) {
                isValid = false;
                errors["email"] = "Please enter valid email address.";
              }
            }        
            /*Password Validation*/
            if (!input["password"]) {
              isValid = false;
              errors["password"] = "Please enter password.";
            }
            this.setState({
              errors: errors
            });
            return isValid;
        }        
        render(){
          return(
            <div className="auth-wrapper" ref={ref}>
            <div className="auth-inner" id="inn" >
            <form className="form-horizontal">
            <h3>Login </h3>
            <div className="form-group row">
                <label >Email address</label>
                  <input type="text" name="email" id="email" className="form-control" placeholder="Enter email address" 
                  onChange={this.myChangeHandler}></input>
                  <small id="passwordHelp" className="text-danger">
                  {this.state.errors.email}
                  </small>      
            </div>
            <div className="form-group row" >

                <label >Password</label>

                    <input className="form-control" type={this.state.isRevealPwd ? "password" : "text"}   placeholder="Enter Password" name="password" onChange={this.myChangeHandler} ></input>
                    <img style={{cursor:"pointer", float:"right",marginLeft: "-25px", marginTop: "10px",position: "relative", zindex: 2,width:20,height:20 }}
                      title={this.state.isRevealPwd ? "Hide password" : "Show password"}
                      src={this.state.isRevealPwd ? hidepwdicon : showpwdicon}
                      onClick={() => this.state.isRevealPwd ? this.setState({isRevealPwd:false}) : this.setState({isRevealPwd:true})} alt=""
                  />

                <small id="passwordHelp" className="text-danger">
                {this.state.errors.password}
                </small>      
            </div>
            <div className="form-group">
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="checkbox1"></input>
                    <label className="custom-control-label" htmlFor="checkbox1">Remember me</label>
                </div>
            </div>
            <button type="submit" className="btn button-primary btn-block" disabled={this.state.bdisabled} onClick={this.handleLogin}>Sign In</button>
            <div className={this.state.errorcss}>{this.state.error}</div>
            <p className="forgot-password text-right">
                Forgot <a href="#/forgotpwd">Password</a>
            </p>
            </form>
{/*}          <button onClick={() => generatePDF(ref, {filename: 'page.pdf'})}>Download PDF</button>*/}

          </div>
          </div>
        );
    }
} 
export default Login;